exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-times[data-v-99e864c4] {\n  top: 5px;\n  right: 26px;\n  z-index: 5;\n}\n.ghost[data-v-99e864c4] {\n  opacity: 0.5;\n  background: #c8ebfb;\n}", ""]);

// exports
